export function DefaultImageCard({
  children,
  image,
  priority = false,
  size = "md",
}: {
  children: React.ReactNode;
  image: string;
  priority?: boolean;
  size?: "sm" | "md";
}) {
  return (
    <ImageCard image={image} priority={priority} size={size}>
      <div className="relative flex flex-col items-end justify-center h-full p-8">{children}</div>
    </ImageCard>
  );
}

export function ImageCard({
  children,
  image,
  priority,
  size,
}: {
  children: React.ReactNode;
  image: string;
  priority: boolean;
  size: "sm" | "md";
}) {
  return (
    <div className="bg-card relative rounded-xl overflow-clip hover:shadow-lg transition-all duration-200">
      <img
        src={image}
        alt=""
        className="absolute inset-0 size-full object-cover pointer-events-none"
        draggable={false}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
      />

      <div
        className="absolute inset-0 size-full"
        style={{
          maskImage: `linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${size === "md" ? "0.3" : "0.5"}), rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 1))`,
        }}
      >
        <div
          className="absolute backdrop-blur-xl bg-black/40"
          style={{
            width: "105%",
            height: "105%",
            top: "-2.5%",
            left: "-2.5%",
          }}
        />
      </div>

      {children}
    </div>
  );
}
